<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
margin: 0;
padding: 0;
}
.header-nav>div{
  margin: 0 11px;
}
a:hover{
  cursor: pointer;
}
.xglj .el-input__inner{
  border: none;
  color: #606266;
  border-radius: 0;
}
.xglj .el-input__inner::placeholder{
  border: none;
  color: #606266;
}
.s2-text img{
  width: 600px !important;
  height: auto !important;
  display: block !important;
  margin: 0 auto !important;

}
.s2-texts  img{
  width: 400px !important;
  height: 560px !important;
  display: block !important;
  margin: 0 auto !important;

}
</style>



// WEBPACK FOOTER //
// src/App.vue